export const API_ENDPOINTS = {
  production: "https://api.coingecko.com/api/v3",
  staging: "https://www.coingecko.xyz/api/v3",
  development: "http://localhost:3000/api/v3"
};

export const ASSET_ENDPOINTS = {
  production: "https://assets.coingecko.com",
  staging: "https://assets-staging.coingecko.com",
  development: "https://assets-development.coingecko.com"
};

export const stockChartOptions = elementId => ({
  time: { useUTC: false },
  chart: {
    backgroundColor: null,
    panning: false,
    marginTop: 50,
    renderTo: `${elementId}`,
    zoomType: 'x'
  },
  rangeSelector: {
    buttons: [],
    inputPosition: {
        align: "right",
        x: 0,
        y: -20
    },
    inputStyle: {
        color: '#999999'
    },
    labelStyle: {
      color: '#999999'
    }
  },
  scrollbar: {
    enabled: false
  },
  plotOptions: {
    line: {
      marker: {
        fillColor: "#3ea9fa", // Styles the line chart
        states: {
          hover: {
            radiusPlus: 4
          }
        }
      },
      animation: false, stickyTracking: true, shadow: false, dataLabels: { style: { textShadow: false } }
    },
    column: {
      color: "#919191", // Styles the volume bars
      animation: false
    }
  },
  exporting: {
    buttons: {
      customButton: {
        text: 'Linear',
        onclick: function() {
          this.yAxis[0].update({
            type: 'linear'
          });
        },
        y: -10
      },
      customButton2: {
        text: 'Logarithmic',
        onclick: function() {
          this.yAxis[0].update({
            type: 'logarithmic'
          });
        },
        y: -10
      },
      contextButton: {
        y: -10
      }
    },
    chartOptions: {
      plotOptions: {
        series: {
          dataLabels: {
            enabled: false
          }
        }
      }
    },
    fallbackToExportServer: false
  },
  credits: {
    text: "CoinGecko.com",
    href: "javascript:;",
    position: {
      align: "right",
      verticalAlign: "top",
      y: 40
    },
    style: {
      cursor: "default"
    }
  },
});

export default {
  API_ENDPOINTS
};
